import { render, staticRenderFns } from "./DashboardTermsModal.vue?vue&type=template&id=54c35388&scoped=true&"
import script from "./DashboardTermsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./DashboardTermsModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DashboardTermsModal.vue?vue&type=style&index=0&id=54c35388&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c35388",
  null
  
)

export default component.exports